<template>
    <div class="codics-aonaer-info-sys-user-body">
        <WebHeader></WebHeader>
        <div class="codics-aonaer-info-sys-user-view">
            <div class="codics-aonaer-info-sys-user-view-container">
                <BreadCrumb class="codics-aonaer-info-sys-user-crumb" :bread-list="breadList"></BreadCrumb>
                <div class="codics-aonaer-info-sys-user-box">
                    <UserLeftTab class="codics-aonaer-info-sys-user-left-tab"></UserLeftTab>
                    <router-view class="codics-aonaer-info-sys-user-right-box"></router-view>
                </div>
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import BreadCrumb from '@/components/BreadCrumb';
import UserLeftTab from '@/components/UserLeftTab';
import LoginDialog from '@/components/LoginDialog';
import { mapState } from 'vuex';
import { userInfos } from '@/api';
export default {
    data() {
        return {
            breadList: [
                {
                    title: '网站首页',
                    url: '#'
                },
                {
                    title: '奥纳尔制冷',
                    url: '#'
                },
                {
                    title: '个人主页',
                    url: '#'
                }
            ]
        }
    },
    components: {
        WebHeader,
        WebFooter,
        BreadCrumb,
        LoginDialog,
        UserLeftTab
    },
    mounted() { 
        
    },
    computed: {
        ...mapState(['userInfo'])
    }
}
</script>

<style>
.codics-aonaer-info-sys-user-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-user-view {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 100px;
    box-sizing: border-box;
    background: #F7F7F7;
}

.codics-aonaer-info-sys-user-view-container {
    height: fit-content;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
}

.codics-aonaer-info-sys-user-crumb {
    margin-top: 50px;
    background: #FFF;
    padding: 0 20px;
}

.codics-aonaer-info-sys-user-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 20px;
    margin-bottom: 60px;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-left-tab {
    width: 260px !important;
}

.codics-aonaer-info-sys-user-right-box {
    height: fit-content !important;
    width: calc(100% - 280px) !important;
    position: relative;
    float: left;
    margin-left: 20px;
    background: #FFF;
}

@media (max-width:768px) {
    .codics-aonaer-info-sys-user-left-tab{
        width: 100% !important;
    }
    .codics-aonaer-info-sys-user-right-box{
        width: 100% !important;
        margin-left: 0 !important;
    }
}
</style>